import styled from 'styled-components';

export const StyledHr = styled.hr`
   margin: 16px 0px;
   color: ${({ theme }) => theme.white};
`;

StyledHr.displayName = 'StyledHr';
